import Api from '.';

export async function getCalendarData(queryParam) {
  let { search, page, perPage, padId, professionId, branchId } = queryParam;

  branchId = branchId || '';
  perPage = perPage || '';
  page = page || '';

  const data = `padId=${padId}&professionId=${professionId}&branchId=${branchId}`;
  const query = `search=${search}&page=${page}&perPage=${perPage}`;

  return Api.get(`/initialize-pad/calendar/lazy?${query}&${data}`);
}

export function getPad(id) {
  return Api.get(`/initialize-pad/pad/${id}`);
}

export function getPadVisit(padVisitId) {
  return Api.get(`/initialize-pad/pad-visit/${padVisitId}`);
}
// export function getPadVisit(padVisitId) {
//   return Api.get(`/pad-visits/bind-professional/${padVisitId}`);
// }

export function initializePadClient(padId, initializePadData) {
  return Api.post(`/initialize-pad/client/${padId}`, initializePadData);
}

export function initializePadCooperative(padVisitId, initializePadData) {
  return Api.post(`/initialize-pad/cooperative/${padVisitId}`, initializePadData);
}
